enum TraumaType {
    Accelerated = "Accelerated",
    Standalone = "Standalone",
    Unknown = "Unknown"
}

export default TraumaType;
